var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    "view-box": "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.98999 0.336409L19.1211 15.4675L15.4913 19.0974L0.360171 3.96622C0.142879 3.74893 0.0207938 3.45421 0.020794 3.14691C0.0207938 2.83962 0.142879 2.5449 0.360171 2.3276L2.37213 0.315647C2.58942 0.0983545 2.88411 -0.023699 3.19141 -0.023699C3.4987 -0.023699 3.79342 0.0983861 4.01072 0.315678L3.98999 0.336409Z",
    fill: "#2E3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0283 20.6727L20.695 17.006L22.0003 21.318C22.0265 21.4066 22.0284 21.5006 22.0057 21.5902C21.9829 21.6797 21.9365 21.7615 21.8711 21.8268C21.8058 21.8921 21.724 21.9386 21.6345 21.9613C21.5449 21.9841 21.4509 21.9823 21.3623 21.956L17.0283 20.6727Z",
    fill: "#2E3333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/EditPen.b9521c78.svg";
export { ForwardRef as ReactComponent };